export type { FeedbackCollectorUIState } from './reducer';
export { feedbackCollectorReducer } from './reducer';
